/* 検索項目 セレクト */
import React, { memo } from 'react';
import SearchLabel from '../atoms/SearchLabel';
import { Col } from 'react-bootstrap';
import Messages from '../molecules/Messages';
var SearchSelect = function (_a) {
    var id = _a.id, label = _a.label, value = _a.value, options = _a.options, onChange = _a.onChange, column = _a.column, with_empty_option = _a.with_empty_option, help_message = _a.help_message, valid_msg = _a.valid_msg;
    return (React.createElement(Col, { md: column ? column : 4 },
        React.createElement(SearchLabel, { label: label }),
        React.createElement("select", { className: "search-form-input long", id: id, value: value, onChange: onChange },
            with_empty_option && React.createElement("option", null),
            options.map(function (option) {
                return (React.createElement("option", { key: option.key, value: option.key }, option.value));
            })),
        React.createElement(Messages, { help_msg: help_message, valid_msg: valid_msg })));
};
export default memo(SearchSelect);
